import type TableQuery from './TableQuery';
import { type TableQueryType } from './TableQuery';
import type SortBy from './SortBy';
import { type SortColumn } from './SortBy';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import type { MailboxInfo } from 'owa-client-types';

export interface MyOutlookTableQuery extends TableQuery {
    sortBy: SortBy;
    mailboxInfo: MailboxInfo;
}

// My Outlook uses a client-only blank table scoped by mailboxInfo; this sentinel is not a
// server folder identifier and must not be used for folder-store lookups or service calls.
const MY_OUTLOOK_FOLDER_ID = 'MyOutlookBlankFolder';
const MY_OUTLOOK_SORT_BY: SortBy = {
    sortColumn: 1,
    sortDirection: 'Descending',
};

export function createMyOutlookTableQuery(mailboxInfo: MailboxInfo): MyOutlookTableQuery {
    return {
        folderId: MY_OUTLOOK_FOLDER_ID,
        listViewType: 1,
        type: 5,
        sortBy: MY_OUTLOOK_SORT_BY,
        mailboxInfo,
    };
}

export function isMyOutlookTable(tableQuery: TableQuery | undefined): boolean {
    return tableQuery?.type === 5;
}
